import React from "react";
import Summary from 'components/Summary';

// Here we just take the userData that is given to us and pass it along to the Summary component,
// just like a normal page
export default ({ userData }) => (
  <Summary userData={userData} readOnly={false} />
)
